
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"52","height":"52","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"52","height":"52","rx":"26","fill":"#F0F4FA"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M19.6 16.4a3.205 3.205 0 00-3.2 3.21v9.63a3.205 3.205 0 003.2 3.21H22v1.542c0 1.356 1.573 2.101 2.617 1.239l3.366-2.78H32.4c1.767 0 3.2-1.438 3.2-3.21v-9.63a3.205 3.205 0 00-3.2-3.211H19.6zm5.333 6.06c0 .592-.477 1.07-1.066 1.07-.59 0-1.067-.478-1.067-1.07 0-.59.478-1.07 1.067-1.07s1.066.48 1.066 1.07zm4.61 2.323c.544.192.838.799.534 1.29a4.79 4.79 0 01-8.095.092c-.316-.484-.035-1.097.504-1.302.539-.204 1.13.09 1.521.515a2.72 2.72 0 002.024.874 2.707 2.707 0 002.003-.92c.381-.433.966-.741 1.51-.55zm-1.41-1.252c.59 0 1.067-.48 1.067-1.07 0-.591-.477-1.07-1.067-1.07-.589 0-1.066.479-1.066 1.07 0 .59.477 1.07 1.066 1.07z","fill":"#525F7F"}})])
          )
        }
      }
    